import { Component } from 'react';
import { store } from 'store';
import { node, func } from 'prop-types';

export const isOnline = () => store.getState().settings.isOnline;
export const isOffline = () => !isOnline();

export const Online = ({ children }) => (isOnline() ? children : null);

Online.propTypes = {
  children: node,
};

export const Offline = ({ children }) => (isOnline() ? null : children);

Offline.propTypes = {
  children: node,
};
export default class NetworkStatus extends Component {
  static propTypes = {
    render: func.isRequired,
  };

  render() {
    return this.props.render({ isOnline: isOnline() });
  }
}



// WEBPACK FOOTER //
// ./src/common/components/NetworkStatus/index.js